export type DiffToken = {
  value: string;
  kind: "same" | "added" | "removed";
};

const tokenize = (value: string) => value.match(/\s+|[\p{L}\p{N}]+|[^\s\p{L}\p{N}]/gu) ?? [];

export function diffTranscript(before: string, after: string): DiffToken[] {
  const left = tokenize(before);
  const right = tokenize(after);
  const rows = left.length + 1;
  const columns = right.length + 1;
  const table = Array.from({ length: rows }, () => Array<number>(columns).fill(0));

  for (let i = left.length - 1; i >= 0; i -= 1) {
    for (let j = right.length - 1; j >= 0; j -= 1) {
      table[i][j] =
        left[i] === right[j]
          ? table[i + 1][j + 1] + 1
          : Math.max(table[i + 1][j], table[i][j + 1]);
    }
  }

  const result: DiffToken[] = [];
  let i = 0;
  let j = 0;

  while (i < left.length && j < right.length) {
    if (left[i] === right[j]) {
      result.push({ value: left[i], kind: "same" });
      i += 1;
      j += 1;
    } else if (table[i + 1][j] >= table[i][j + 1]) {
      result.push({ value: left[i], kind: "removed" });
      i += 1;
    } else {
      result.push({ value: right[j], kind: "added" });
      j += 1;
    }
  }

  while (i < left.length) {
    result.push({ value: left[i], kind: "removed" });
    i += 1;
  }

  while (j < right.length) {
    result.push({ value: right[j], kind: "added" });
    j += 1;
  }

  return result;
}
